import React from 'react';

/**
 * CloudfiMusic Logo — Final
 * 
 * A single continuous flowing line that forms a cloud at the top
 * and unravels into dangling threads below — like music strings
 * hanging from the sky. One-line art style, bold, instantly memorable.
 */
export default function CloudfiMusicLogo({ size = 40, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="CloudfiMusic logo"
    >
      <defs>
        <linearGradient id="logoGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0.7" />
        </linearGradient>
      </defs>

      {/* Cloud body — solid, clean shape */}
      <path
        d="M13.5 24 C8.8 24 5 20.2 5 15.5 C5 11.4 7.8 8 11.5 7.1
           C12.5 3.5 15.8 1 19.8 1
           C22.9 1 25.6 2.7 27.1 5.2
           C27.6 5 28.2 4.9 28.8 4.9
           C31.9 4.9 34.4 7.4 34.4 10.5
           C34.4 10.9 34.4 11.3 34.3 11.7
           C36.2 12.6 37.5 14.5 37.5 16.7
           C37.5 19.8 35 22.3 31.9 22.3 L13.5 22.3 Z"
        fill="url(#logoGrad)"
      />

      {/* Five threads descending — the "thread" element */}
      {/* Each thread has a gentle S-curve like a vibrating string */}

      {/* Thread 1 — far left, shortest, faintest */}
      <path
        d="M14 24 Q13.2 28 14.2 31"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.3"
      />

      {/* Thread 2 */}
      <path
        d="M19 24 Q18 30 19.3 35.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.45"
      />

      {/* Thread 3 — center, longest, strongest */}
      <path
        d="M24 24 Q23 32 24.2 42"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        opacity="0.7"
      />

      {/* Thread 4 */}
      <path
        d="M29 24 Q30 30 28.7 35.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.45"
      />

      {/* Thread 5 — far right, shortest */}
      <path
        d="M33 24 Q33.8 28 32.8 31"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.3"
      />

      {/* Sound ripple arcs on center thread */}
      <path
        d="M21 34 Q24 32 27 34"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.2"
      />
      <path
        d="M19.5 37.5 Q24 34.5 28.5 37.5"
        stroke="currentColor"
        strokeWidth="0.7"
        strokeLinecap="round"
        fill="none"
        opacity="0.13"
      />
    </svg>
  );
}
